import React from 'react';
import * as S from './BookingInfo.styles';
import TripRefundDetails from '../../../../myTripsListing/ListingBody/BookingCard/BookingCardInfoDetails/TripRefundDetails/TripRefundDetails';

const BookingInfo = ({bookingInfo}) => {
  if (!bookingInfo) {
    return null;
  }
  const {refundStatus, header, subHeader, hotelName} = bookingInfo;
  if (!refundStatus.length) {
    return null;
  }
  const data = {
    refund_status: refundStatus,
    status_message: subHeader
  }
  return(
    <S.TripBookingInfoWrap>
      <S.TripBookingInfoHeaderWrap>
        <S.TripInfoHeaderText>REFUND STATUS</S.TripInfoHeaderText>
        <S.TripInfoHeaderInfo>{header}</S.TripInfoHeaderInfo>
      </S.TripBookingInfoHeaderWrap>

      <S.TripBookingStatusWrap>
        <S.HotelNameText>Refund Status for {hotelName}</S.HotelNameText>
        <TripRefundDetails data={data} />
      </S.TripBookingStatusWrap>
    </S.TripBookingInfoWrap>
  );
}

export default BookingInfo;